/* eslint-disable arrow-body-style */
import { useMemo } from 'react';
import img from '../../assets/images/foguinhos.png';
import Center from '../../assets/styles/Center';
import DefaultContainer from '../../assets/styles/DefaultContainer';
import Text from '../../assets/styles/Text';
import Error from '../../components/Error';
import Loader from '../../components/Loader';
import { usePlans } from '../../hooks/queries/usePlans';
import { useUpgrades } from '../../hooks/queries/useUpgrades';
import Plan from './components/Plan';
import Upgrade from './components/Upgrade';
import * as styles from './styles';

export default function Plans() {
  const {
    data: plans = [],
    isLoading: isLoadingPlans,
    isError: isErrorPlans,
    error: plansError,
  } = usePlans();

  const {
    data: upgrades = [],
    isLoading: isLoadingUpgrades,
    isError: isErrorUpgrades,
    error: upgradesError,
  } = useUpgrades();

  // Separate stand-alone plan and subscription
  const separatePlans = useMemo(() => {
    return plans.filter((plan) => plan && typeof plan === 'object' && plan.signature !== true);
  }, [plans]);

  const signaturePlans = useMemo(() => {
    return plans.filter((plan) => plan && typeof plan === 'object' && plan.signature === true);
  }, [plans]);

  // Loading de ambos
  const isLoading = isLoadingPlans || isLoadingUpgrades;
  const isError = isErrorPlans || isErrorUpgrades;

  if (isLoading) {
    return <Loader isLoading />;
  }

  if (isError) {
    return (
      <Error isError message={upgradesError.message || plansError.message} />
    );
  }

  return (
    <DefaultContainer>
      <Center className="center">
        <styles.Container>
          <styles.Title>
            <Text.H1>Planos</Text.H1>
            <Text.H2>
              Para <br />
              Acompanhantes
            </Text.H2>
          </styles.Title>

          <styles.GroupPlan>
            {separatePlans.map((plan) => (
              <Plan plan={plan} key={plan.id} />
            ))}
          </styles.GroupPlan>

          <styles.Title>
            <Text.H1>ASSINATURAS</Text.H1>
            <Text.H2>
              Para <br />
              Acompanhantes
            </Text.H2>
          </styles.Title>

          <styles.GroupPlan>
            {signaturePlans.map((plan) => (
              <Plan plan={plan} key={plan.id} />
            ))}
          </styles.GroupPlan>

          <styles.GroupPlan>
            {upgrades
              .filter((upgrade) => upgrade && typeof upgrade === 'object')
              .map((upgrade) => (
                <Upgrade upgrade={upgrade} key={upgrade.id} />
              ))}
          </styles.GroupPlan>

          <img src={img} alt="about" />
        </styles.Container>
      </Center>
    </DefaultContainer>
  );
}
